module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="signup-form-step">\n  ';
 if (position) { ;
__p += '\n    <div class="featured-position">\n      ';
 if (position.logo_url) { ;
__p += '\n        <div style="background-image: url(' +
__e( position.logo_url ) +
');" class="company-logo"></div>\n      ';
 } ;
__p += '\n      <a class="no-underline" href="' +
__e( position.link ) +
'">\n        <h4>' +
__e( position.title ) +
'</h4>\n      </a>\n      <p class="small">\n        ';
 if (position.city) { ;
__p += '\n          ' +
__e( position.company_name ) +
' - ' +
__e( position.city ) +
'<br />\n          $' +
__e( position.wage ) +
'/hour\n        ';
 } else { ;
__p += '\n          ' +
__e( position.company_name ) +
' - $' +
__e( position.wage ) +
'/hour\n        ';
 } ;
__p += '\n      </p>\n    </div>\n  ';
 } ;
__p += '\n\n  <div class="spacer"></div>\n  <b>Welcome back! Login to apply</b>\n\n  <div class="form-group">\n    <input type="text"\n      id="login-handle"\n      value="' +
__e( handle ) +
'"\n      class="fs-hide"\n      placeholder="Email or phone"\n      autocorrect="off" />\n  </div>\n\n  <div class="form-group">\n    <input type="password"\n      id="login-password"\n      class="fs-hide"\n      placeholder="Password"\n      autocorrect="off" />\n  </div>\n\n  <button id="btn-login" class="btn btn-large btn-primary">\n    Log in\n  </button>\n  <span id="login-error" class="help-block hidden"></span>\n\n  <p>\n    I don\'t have an account.\n    <a href="#" class="js-toggle-signup-link">\n      Create one now\n    </a>\n  </p>\n  <p>\n    <a href="#" class="js-reset-link">\n      Forgot password?\n    </a>\n  </p>\n</div>\n';

}
return __p
}